import { useState } from "react";
import { useDispatch } from "react-redux";
import { addCategory } from "../slices/categorySlice";

const CategoryModal = ({isOpen,onClose}) => {
  const [formData, setFormData] = useState({
    name: "",
  });
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(addCategory(formData));

    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>
        <h2>Yeni kateqoriya yarat</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Kateqoriya Adı"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <button type="submit" className="submit-btn">
            Yarat
          </button>
        </form>
      </div>
    </div>
  );
};

export default CategoryModal;
